

import { FC } from 'react';

import { Icon16Globe } from '@vkontakte/icons';
import { Separator } from '@vkontakte/vkui';
import { useSelector } from 'react-redux';

import styles from './Footer.module.css';
import { selectIsDesktop } from '../../store/settingsSlice/settingsSelectors';

export const SITE_URL = 'https://dscs.pro';
export const VK_URL = 'https://vk.com/dscspro';
export const TELEGRAM_URL = 'https://t.me/DSCSproAI';

export const Footer: FC = () => {
  const isDesktop = useSelector(selectIsDesktop);

  return (
    <div className={styles.container}>
      <Separator/>
      <h3 className={styles.title}>Разработано командой DSCS.pro</h3>
      <p className={styles.text} style={isDesktop ? { maxWidth: '70%' } : undefined}>— исследователями, создающими комплексные высокотехнологичные программные решения и&nbsp;проводящими научные исследования в сфере IT</p>
      <div className={styles.links_container}>
        <a href={VK_URL} target="_blank" rel="noreferrer">   
          <div className={styles.button}>
            <img src="./icons/vk.svg"/>
          </div>
        </a> 
        <a href={TELEGRAM_URL} target="_blank" rel="noreferrer">
          <div className={styles.button}>
            <img src="./icons/telegram.svg"/>
          </div>
        </a>
        <a href={SITE_URL} target="_blank" rel="noreferrer">
          <div className={styles.button}>
            <Icon16Globe className={styles.icon}/>
          </div>
        </a>   
      </div>
    </div>
  );
};  

